import { withErrorBoundary } from "@sentry/nextjs";
import NextLink, { LinkProps } from "next/link";
import { FC, ReactNode } from "react";
import styled from "styled-components";
import { isBlockedPrefetchHref } from "lib/utils/isBlockedPrefetchUrl";
import { parseLinkToEnv } from "lib/utils/parseLinkToEnv";

interface Props extends Omit<LinkProps, "href"> {
  children: ReactNode;
  className?: string;
  href: string;
}

const Link: FC<Props> = withErrorBoundary(({ href, children, className = "", ...props }) => {
  if (!href) {
    return <StyledButton className={className}>{children}</StyledButton>;
  }

  const hrefLink = parseLinkToEnv(href);

  if (isBlockedPrefetchHref(hrefLink)) {
    return (
      <StyledLink as="a" className={className} href={hrefLink} rel="noopener noreferrer" target="_blank">
        {children}
      </StyledLink>
    );
  }

  return (
    <NextLink href={hrefLink} passHref {...props}>
      <StyledLink className={className}>{children}</StyledLink>
    </NextLink>
  );
}, {});

const StyledLink = styled.span`
  width: fit-content;
  display: flex;
`;

const StyledButton = styled.div`
  width: fit-content;
  display: flex;
  cursor: pointer;
`;

export { Link };
